import React, { useEffect } from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Btn2 } from "./btn";

export default function ExitPopup({ onClose, value, data }) {
  useEffect(() => {
    // document.body.style.overflow = "hidden";
    // return () => {
    //   document.body.style.overflow = "unset";
    // };
    if (value) {
      document.getElementById("popup").style.visibility = "visible";
      document.getElementById("popup").style.opacity = "1";
    } else {
      document.getElementById("popup").style.opacity = "0";
      setTimeout(() => {
        document.getElementById("popup").style.visibility = "hidden";
      }, 500);
    }
  }, [value]);
  return (
    <div
      className={`fixed top-0 transition-opacity duration-700 ${
        value ? "visible" : "hidden"
      } bottom-0 left-0 right-0 bg-black/30 z-[150] backdrop-blur-[4.5px]`}
      id="popup"
      aria-modal="true"
      role="dialog"
      aria-labelledby="exit-popup-heading"
    >
      <div className="absolute blur-xl top-0 left-0 right-0 bottom-0" />
      <div className="flex h-full w-full justify-center items-center z[100]">
        <div className="w-[949px] bg-white rounded relative border border-solid border-primary">
          <button
            className="absolute z-50 right-3 top-2 p-1 cursor-pointer text-white"
            onClick={onClose}
            aria-label="Close exit popup"
            type="button"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <div className="max-h-[400px] overflow-hidden relative">
            <GatsbyImage
              image={data?.image?.asset?.gatsbyImageData}
              placeholder="blurred"
              alt="welcome"
              className="rounded-tl rounded-tr"
            />
          </div>
          <div className="py-[29px] px-[44px] relative">
            <div className="relative">
              <h2
                id="exit-popup-heading"
                className="font-bold text-black leading-[29px] text-base sm:text-[20px] mb-3"
              >
                {data?.heading}
              </h2>
              <p className="text-xs sm:text-base leading-6 font-poppins">
                {data?.description}
              </p>
              <div className="flex flex-wrap gap-4 mt-6">
                {data?.button?.buttonText && (
                  <div className="w-[258px]">
                    <Btn2 data={data.button} />
                  </div>
                )}
                {data?.button2?.buttonText && (
                  <div className="w-[258px]">
                    <Btn2 data={data.button2} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
